import { render, staticRenderFns } from "./InvalidCode.vue?vue&type=template&id=01737f0c&"
import script from "./InvalidCode.vue?vue&type=script&lang=js&"
export * from "./InvalidCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports